<template>
  <div class="container">
    <div class="header-search">
      <img src="@/assets/img/icon_yaopin.png" alt="" />
      <div class="search-box">
        <!-- <a-select
          v-model="version"
          style="width: 120px"
          @change="onSearch"
          class="search-input"
        >
          <a-select-option value="1"> 旧版 </a-select-option>
          <a-select-option value="2"> 新版 </a-select-option>
        </a-select> -->
        <a-select
          v-model="applyCampus"
          style="width: 120px"
          @change="handleChange"
          class="search-input"
        >
          <a-select-option value=""> 全部 </a-select-option>
          <a-select-option value="玉泉"> 玉泉 </a-select-option>
          <a-select-option value="西溪"> 西溪 </a-select-option>
          <a-select-option value="华家池"> 华家池 </a-select-option>
          <a-select-option value="紫金港"> 紫金港 </a-select-option>
        </a-select>
        <a-input-search
          v-model="drugName"
          placeholder="请输入药品查询"
          @search="onSearch"
          class="search-input"
        />
        <a-button size="large" type="primary" @click="onSearch">查询</a-button>
      </div>
    </div>
    <div class="container-content">
      <a-breadcrumb separator=">">
        <a-breadcrumb-item href="" @click.native="() => $router.push('/')"
          >首页</a-breadcrumb-item
        >
        <a-breadcrumb-item>药品查询</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="container-content">
      <div class="result">常见药品/查询结果</div>
      <div class="content-list">
        <div class="content">
          <a-card
            hoverable
            class="item-card"
            :key="item.id"
            v-for="item in list"
            @click="onDetail(item)"
          >
            <h3>{{ item.drugName }}</h3>
            <div class="fontColor">规格：{{ item.specification }}</div>
            <div class="fontColor">产地：{{ item.originName }}</div>
            <div class="fontColor">药房名称：{{ item.pharmacyName }}</div>
          </a-card>
        </div>
      </div>

      <a-pagination
        show-quick-jumper
        v-model="currentpage"
        :show-total="total => `共 ${total} 条`"
        :page-size="pageSize"
        :total="total"
        @change="onChange"
      />
    </div>
  </div>
</template>

<script>
import { getList, getList2 } from "@/api/drug";
export default {
  components: {},
  data() {
    return {
      version: "1",
      currentpage: 1,
      pageSize: 12,
      total: 0,
      drugName: "",
      applyCampus: "",
      list: [],
    };
  },
  created() {
    this.getDataList();
  },
  methods: {
    handleChange() {
      this.onSearch();
    },
    onChange(val) {
      this.currentpage = val;
      this.getDataList();
    },
    onSearch() {
      this.currentpage = 1;
      this.list = [];
      this.getDataList();
    },
    // 获取数据列表
    async getDataList() {
      const params = {
        applyCampus: this.applyCampus, // 校区,
        drugName: this.drugName, //药品名称 支持模糊查询
        pageNum: this.currentpage, //页码 默认为1
        pageSize: this.pageSize, //每页记录数 默认为10
      };
      const { code, data, total } =
        this.version == 2 ? await getList2(params) : await getList(params);
      if (code == 200) {
        this.list = data;
        this.total = total;
      }
    },
    toHome() {
      this.$router.push("/");
    },
    onDetail(data) {
      this.$router.push({
        path: "/drugDetail",
        query: { data: JSON.stringify(data),version:this.version },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fontColor1 {
  color: #fe695c;
  font-size: 14px;
}

.fontColor {
  color: #8e8e8e;
  font-size: 14px;
}

.fontstyle {
  font-size: 14px;
  cursor: pointer;
}

.center {
  margin-top: 52px;
  text-align: center;

  .inform {
    margin: 12px 0;
  }
}

.flex {
  display: flex;
  justify-content: space-evenly;
}

.container {
  max-width: 100%;
  margin: 0;
  .container-content {
    max-width: 1200px;
    margin: 20px auto 0;
  }

  .header-search {
    img {
      margin-top: 87px;
      margin-bottom: 30px;
      height: 50px;
    }

    background: #3763e0;
    height: 305px;
    background: #3763e0;
    text-align: center;
    margin-bottom: 12px;

    .search-input {
      width: 850px;
      height: 44px;
      margin-right: 12px;
    }
    .ant-select {
      height: 44px;
    }

    /deep/ .ant-select-selection--single {
      height: 44px;
      line-height: 44px;
    }
    /deep/ .ant-select-selection__rendered {
      height: 44px;
      line-height: 44px;
    }
    .search-box {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .result {
    position: relative;
    height: 33px;
    font-size: 24px;
    font-weight: 600;
    color: #333333;
    line-height: 33px;
    margin-bottom: 30px;
  }

  .result::after {
    position: absolute;
    bottom: -10px;
    left: 0;
    content: "";
    height: 6px;
    width: 204px;
    background: #3f86ff;
  }
  .content-list {
    min-height: 630px;
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;

    .item-card {
      width: 380px;
      margin: 0 7px;
      margin-bottom: 15px;

      h3 {
        font-size: 15px;
        font-weight: 600;
      }

      div {
        font-size: 14px;
      }
    }
  }
}
</style>
